export default {
    user: {
        loggedIn: localStorage.getItem('LOGGEDIN') ? true : false,
        isAdmin: localStorage.getItem('USERROLE') === 'Admin' ? true : false,
        isOperator: localStorage.getItem('USERROLE') === 'Operator' ? true : false,
        isSeller: localStorage.getItem('USERROLE') === 'Seller' ? true : false,
        token: localStorage.getItem('TOKEN') ? localStorage.getItem('TOKEN') : null,
        data: JSON.parse(localStorage.getItem('USER')) ? JSON.parse(localStorage.getItem('USER')) : {},
    },

    operators: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    allCategories: {
        loading: false,
        data: [],
    },

    allTags: {
        loading: false,
        data: [],
    },

    categoriesWithAttributes: {
        loading: false,
        data: [],
    },

    categoriesWithProducts: {
        loading: false,
        data: [],
    },

    categories: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    attributes: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    attributesNoPagination: {
        loading: false,
        data: [],
    },

    allAttributes: {
        loading: false,
        data: [],
    },

    categoryAttributes: {
        loading: false,
        data: [],
    },

    values: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    attributeValues: {
        loading: false,
        data: [],
    },

    productCreators: {
        loading: false,
        data: [],
    },

    products: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    users: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    sliders: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    stores: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    orders: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    transactions: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    walletTransactions: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    banners: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    comments: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    faqs: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    messages: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    allOccasionTypes: {
        loading: false,
        data: [],
    },

    occasions: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    occasionTypesWithOccasions: {
        loading: false,
        data: [],
    },

    allStoreSales: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    tags: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    cooperationRequests: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },

    allStoreSettlements: {
        loading: false,
        data: [],
        links: [],
        from: null,
        to: null,
        page: 1,
        limit: null,
        total: null
    },


    bestSellingProducts: {
        loading: true,
        data: [],
    },

    topSellingStores: {
        loading: true,
        data: [],
    },

    lastPendingOrders: {
        loading: true,
        data: [],
    },

}